/// Update patchDarkMode.js - Add better logging
(function() {
  console.log('🚀 Applying nuclear darkMode patch...');
  
  // Track where errors come from
  let errorCount = 0;
  
  // 1. Patch global object to always have darkMode
  if (typeof global !== 'undefined') {
    global._darkModeValue = false;
    global.getDarkMode = () => global._darkModeValue;
    global.setDarkMode = (value) => {
      global._darkModeValue = Boolean(value);
      return true;
    };
  }
  
  // 2. Ultra-aggressive error handler with stack trace logging
  const originalErrorHandler = ErrorUtils?.getGlobalHandler?.();
  
  if (ErrorUtils?.setGlobalHandler) {
    ErrorUtils.setGlobalHandler((error, isFatal) => {
      // Check for ANY darkMode related error
      if (error?.message && (
        error.message.includes('darkMode') ||
        error.message.includes('darkmode') ||
        error.message.includes("Property 'darkMode'") ||
        error.message.includes('Cannot read property') && error.message.includes('darkMode')
      )) {
        errorCount++;
        console.log(`🛡️ NUCLEAR PATCH ${errorCount}: Suppressed darkMode error`);
        console.log('Error message:', error.message);
        console.log('Stack trace:', error.stack);
        
        // Log additional info to help find the source
        if (errorCount === 1) {
          console.log('🔍 FIRST darkMode error detected!');
          console.log('This is likely the initial error source');
        }
        
        // Don't crash - just log and continue
        return;
      }
      
      // Pass other errors to original handler
      if (originalErrorHandler) {
        originalErrorHandler(error, isFatal);
      }
    });
  }
  
  // 3. Monkey-patch console.error to catch darkMode errors earlier
  const originalConsoleError = console.error;
  console.error = function(...args) {
    if (args.some(arg => 
      typeof arg === 'string' && (
        arg.includes('darkMode') ||
        arg.includes("Property 'darkMode'") ||
        arg.includes('undefined is not an object') && arg.includes('darkMode')
      )
    )) {
      console.log('🔍 console.error caught darkMode reference:', args);
    }
    originalConsoleError.apply(console, args);
  };
  
  console.log('✅ Nuclear darkMode patch applied successfully');
})();
// In patchDarkMode.js, add this:
global.darkMode = false;
global.window = global.window || {};
global.window.darkMode = false;
global.navigator = global.navigator || {};
global.navigator.darkMode = false;

// Patch Object.defineProperty to prevent darkMode from being undefined
const originalDefineProperty = Object.defineProperty;
Object.defineProperty = function(obj, prop, descriptor) {
  if (prop === 'darkMode' && descriptor && descriptor.get) {
    descriptor.get = function() { return false; };
  }
  return originalDefineProperty.call(this, obj, prop, descriptor);
};